import gridTypeRawString from '../../fragments/GridType.graphql'

export const gridTypeString = gridTypeRawString

export type GridType = {
  __typename: 'ComponentSharedGridArea'
  colStart: string
  colEnd: string
  rowEnd: string
  rowStart: string
}

export const isGridType = (fragment: any): fragment is GridType =>
  fragment &&
  fragment.__typename === 'ComponentSharedGridArea' &&
  typeof fragment.colStart === 'string' &&
  typeof fragment.colEnd === 'string' &&
  typeof fragment.rowEnd === 'string' &&
  typeof fragment.rowStart === 'string'
